import styled from "styled-components";
import { MOBILE_WIDTH } from "../../constants";
import { Link } from "gatsby";

export const FooterContainer = styled.div`
  width: 100%;
  height: 450px;
  background-color: #fff;
  display: flex;
  overflow: hidden;
  @media ${MOBILE_WIDTH} {
    flex-direction: column-reverse;
    height: 650px;
  }
`;

export const MapContainer = styled.div`
  width: 60%;
  height: 100%;
  background-color: "#f2f2f2";
  display: flex;
  @media ${MOBILE_WIDTH} {
    width: 100%;
  }
`;

export const ContactContainer = styled.div`
  width: 100%;
  max-height: 450px;
  padding: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: start;
  @media ${MOBILE_WIDTH} {
    padding: 16px;
    width: auto;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Paragraph = styled.p`
  font-family: Oswald;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  color: #000000;
  margin: 0;
`;

export const Logo = styled.img`
  width: 100px;
  margin-left: auto;
  @media ${MOBILE_WIDTH} {
    width: 60px;
  }
`;

export const StyledLink = styled(Link)`
  color: #fff;
  cursor: pointer;
  background-color: #000;
  color: #fff;
  padding: 8px;
  width: 112px;
  border-width: 0;
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  :hover {
    opacity: 0.6;
  }
`;
